export default "__VITE_ASSET__DR6dHiCf__"